import { render } from "./j-city.vue?vue&type=template&id=4e93e2ff&scoped=true"
import script from "./j-city.vue?vue&type=script&lang=js"
export * from "./j-city.vue?vue&type=script&lang=js"

import "./j-city.vue?vue&type=style&index=0&id=4e93e2ff&scoped=true&lang=less"

import exportComponent from "/Users/jiangwen/GitHub/xiamao-mall/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e93e2ff"]])

export default __exports__